import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import moment from "moment";
import { toast } from 'react-toastify';

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";

//Assets
import CopyIcon from "../../../../images/copy-icon.png";
import PickupAddress from "../../../../images/pickup-address.png";
import ScheduledIcon from "../../../../images/scheduled.png";
import Scooter from "../../../../images/scooter.png";
import Delivery from "../../../../images/delivery.png";
import IconDownload from "../../../../images/icon-download.png";

//Helper
import { CopyToClipboard, dateHandler as dateHandlerHelpers, momentHandler } from "../../../../utils/Helpers";

//Interface
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  loading,
  orderDetails,
  downloadHandler,
  seeNote,
  onBack,
  currencyHandler
}) => {
  const { order_id, origin, courier, package: _package, time_slot_selected } = orderDetails || {};
  const { max_day, min_day, price_breakdown, use_insurance } = courier || {};

  const oneEta = max_day == min_day;
  const RenderDay = (day) => day > 1 ? "days" : "day";
  const RenderEtaText = () => {
    if (oneEta) return <span className="eta">ETA delivery: {min_day} {RenderDay(min_day)}</span>
    return <span className="eta">ETA delivery: {min_day} {RenderDay(min_day)} - {max_day} {RenderDay(max_day)}</span>
  }

  const dayHandler = () => {
    try {
      if (moment(time_slot_selected?.start_time).isSame(time_slot_selected?.start_time, "day")) return "Today";
      return momentHandler(time_slot_selected?.start_time, 'dddd');
    } catch (err) {
      console.log(err, "Error when parsing hours fn dayHandler file PikcupScheduledDetails.tsx")
      return ""
    }
  }
  const hoursHandler = () => {
    try {
      const start_hour = momentHandler(time_slot_selected?.start_time, 'HH:MM');
      const end_hour = momentHandler(time_slot_selected?.end_time, 'HH:MM');

      return <span>{start_hour} - {end_hour}</span>
    } catch (err) {
      console.log(err, "Error when parsing hours fn hoursHandler file PikcupScheduledDetails.tsx")
      return <span></span>
    }
  }
  const dateHandler = () => {
    try {
      const date = momentHandler(time_slot_selected?.start_time, 'Do');
      const _date = dateHandlerHelpers(date)

      return <span className="date">{_date[0]}<span className="suffix">{_date[1]}</span></span>
    } catch (err) {
      console.log(err, "Error when parsing hours fn dateHandler file PikcupScheduledDetails.tsx")
      return <span></span>
    }
  }

  const monthHandler = () => momentHandler(time_slot_selected?.start_time, 'MMM');
  const yearHandler = () => momentHandler(time_slot_selected?.start_time, 'YYYY');

  const CoppHandler = () => {
    CopyToClipboard(order_id)

    toast.success(
      "Copied",
      {
        position: 'top-right',
        autoClose: 1000,
        closeOnClick: true,
        pauseOnHover: true
      },
    );
  }

  return (
    <CustomBody loading={loading}>
      <div className="pickup-details-body">
        <p className="title">Pick-up Details</p>
        <p className="sub-title" onClick={() => seeNote()}>See Pick-up Notes</p>
        <div className="pickup-details-wrapper">
          <div className="order-id-wrapper">
            <p className="order-text">Shipper Order ID</p>
            <p className="order-number">{order_id} <KickImage onClick={CoppHandler} className="copy-icon" src={CopyIcon} alt="copy" /></p>
          </div>

          <div className="order-detail-card">
            <KickImage className="detail-card-icon" src={PickupAddress} alt="pickup-address" />
            <div className="pickup-detail-info">
              <p className="info-title">Pick-up Address</p>
              <p className="info-address">{origin?.address}, {origin?.suburb_name}, <br /> {origin?.city_name} {origin?.province_name}, {origin?.postal_code}, {origin?.country}</p>
            </div>
          </div>

          <div className="order-detail-card">
            <KickImage className="detail-card-icon" src={Scooter} alt="pickup-address" />
            <div className="pickup-detail-info">
              <p className="info-title">Service</p>
              <div className="pickup-detail-last-text">
                <span>{courier?.name} {courier?.rate_name}</span>
                <span>{RenderEtaText()}</span>
              </div>
            </div>
          </div>

          <div className="order-detail-card">
            <KickImage className="detail-card-icon" src={ScheduledIcon} alt="pickup-address" />
            <div className="pickup-detail-info">
              <p className="info-title">Pick-up schedule</p>
              <div className="pickup-detail-last-text">
                <span>{dayHandler()}, {dateHandler()} {monthHandler()} {yearHandler()}</span>
                {hoursHandler()}
              </div>
            </div>
          </div>

          <div className="order-detail-card total-payment no-border">
            <div className="total-payment-wrapper">
              <KickImage className="detail-card-icon" src={Delivery} alt="pickup-address" />
              <div className="pickup-detail-info">
                <p className="info-title">Total Payment</p>
                <p className="info-address">Total payment will be automatically taken from the revenue after the sales completed.</p>
              </div>
            </div>
          </div>

          <div className="order-detail-card payment-detail-wrapper">
            <div className="payment-detail-card">
              <span>Shipping fee</span>
              <span>{currencyHandler(price_breakdown?.base_price || 0)}</span>
            </div>

            {use_insurance ? <div className="payment-detail-card">
              <span>Insurance</span>
              <span>{currencyHandler(price_breakdown?.insurance_fee || 0)}</span>
            </div> : null}

            {price_breakdown?.discount ? <div className="payment-detail-card">
              <span>Discount</span>
              <span>- {currencyHandler(price_breakdown?.discount || 0)}</span>
            </div> : null}

            <div className="payment-detail-card total">
              <span>Total</span>
              <span>{currencyHandler(price_breakdown?.final_price || 0)}</span>
            </div>
          </div>

          <div className="order-detail-card download-wrapper no-border">
            <p className="download" onClick={downloadHandler}><KickImage className="icon-download" src={IconDownload} alt="download" />Download receipt</p>
          </div>
        </div>
        <CustomButton
          text={"OK"}
          disabled={false}
          onClick={() => onBack()}
        />
      </div>
    </CustomBody>
  )
}
export default Component;